<div class="page-content page-fill">
    <h2><a [attr.href]="serviceName + '/reports/directory'" target="_blank">Church Directory</a></h2>
    <h2><a [attr.href]="serviceName + '/reports/directory?showAsterisks=true'" target="_blank">Church Directory (with *)</a></h2>
    <h2 class="mt-4"><a [attr.href]="serviceName + '/reports/pictureDirectory'">Picture Directory</a></h2>
    <h2><a [attr.href]="serviceName + '/reports/pictureDirectory?showAsterisks=true'">Picture Directory (with *)</a></h2>
    <h2><a [attr.href]="serviceName + '/reports/pictureDirectory?imageQuality=low'">Picture Directory (lower image quality)</a></h2>
</div>
